






import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    priority: {
      type: String as PropType<Props["priority"]>,
      default: "primary",
      validator: function(value) {
        return ["primary", "secondary", "tertiary"].includes(value);
      }
    },
    maxLineClamp: {
      type: Number,
      default: 0
    }
  },
  computed: {
    priorityClasses() {
      return {
        "body--primary": this.priority === "primary",
        "body--secondary": this.priority === "secondary",
        "body--tertiary": this.priority === "tertiary"
      };
    },
    lineClampStyle() {
      return this.maxLineClamp
        ? {
            display: "-webkit-box",
            overflow: "hidden",
            maxHeight: `calc(1em * 1.4 * ${this.maxLineClamp})`,
            "-webkit-line-clamp": `${this.maxLineClamp}`,
            "-webkit-box-orient": "vertical"
          }
        : {};
    }
  }
});
